import React from 'react';
import './MediaLinks.css';

import wa from '../../../assets/icons/whatsapp.svg';
import li from '../../../assets/icons/linkedin.svg';
import gh from '../../../assets/icons/github.svg';
import be from '../../../assets/icons/behance.svg';
import gm from '../../../assets/icons/gmail.svg';

export const MediaLinks = () => {
    return(
        <div className='media-links'>
            <a href='https://wa.me/573043802094' target='_blank' className='media-links__item'>
                <img src={wa} alt="WhatsApp" />
            </a>
            <a href='https://www.linkedin.com/in/diego-andr%C3%A9s-escobar-duque-86558871/' target='_blank' className='media-links__item'>
                <img src={li} alt="LinkedIn" />
            </a>
            <a href='https://github.com/daedsoft' target='_blank' className='media-links__item'>
                <img src={gh} alt="GitHub" />
            </a>
            <a href='https://www.behance.net/daed_drawing?tracking_source=search_users%7Cdiego%20andres%20escobar' target='_blank' className='media-links__item'>
                <img src={be} alt="Béhance" />
            </a>
            <a href='mailto:daedcoder@gmail.com' target='_blank' className='media-links__item'>
                <img src={gm} alt="Gmail" />
            </a>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/profile-container/media-links/MediaLinks.jsx